import { BOOKING_API_URL, supabase } from '../lib/supabase';

// 'payment_request' = de betaallink-mail voor unpaid boekingen (ClickUp
// 869d7wrww): bedrag + knop naar de manage-pagina met &pay=1.
export type ResendEmailAction = 'confirmation' | 'manage_link' | 'payment_request';

export interface ResendEmailRequest {
  booking_id: string;
  action: ResendEmailAction;
}

export interface ResendEmailResponse {
  ok: boolean;
  booking_id: string;
  booking_number: string;
  action: ResendEmailAction;
  rotated: boolean;
  resend_id: string | null;
}

export interface ResendEmailError {
  error: string;
  message?: string;
}

export interface ResendEmailResult {
  ok: boolean;
  data: ResendEmailResponse | null;
  error: ResendEmailError | null;
  status: number;
}

export async function resendBookingEmail(
  body: ResendEmailRequest,
): Promise<ResendEmailResult> {
  const { data: sessionData } = await supabase.auth.getSession();
  const jwt = sessionData.session?.access_token;
  if (!jwt) {
    return {
      ok: false,
      data: null,
      error: { error: 'unauthenticated', message: 'No active session' },
      status: 401,
    };
  }

  let res: Response;
  try {
    res = await fetch(`${BOOKING_API_URL}/booking-resend-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${jwt}`,
      },
      body: JSON.stringify(body),
    });
  } catch (e) {
    return {
      ok: false,
      data: null,
      error: {
        error: 'network_error',
        message: e instanceof Error ? e.message : String(e),
      },
      status: 0,
    };
  }

  let json: unknown = null;
  try {
    json = await res.json();
  } catch {
    /* empty / non-JSON */
  }

  if (!res.ok) {
    return {
      ok: false,
      data: null,
      error: (json as ResendEmailError) ?? {
        error: 'unknown_error',
        message: `HTTP ${res.status}`,
      },
      status: res.status,
    };
  }

  return {
    ok: true,
    data: json as ResendEmailResponse,
    error: null,
    status: res.status,
  };
}
